var cookieTLDRegex = /\.?[^.]+\.[^.]+$/;
var stripWWWRegex = /\b(?!(?:https?|ftps?):\/\/)(?!www\.)(?:[0-9A-Za-z][0-9A-Za-z-]{0,62})(?:\.(?:[0-9A-Za-z][0-9A-Za-z-]{0,62}))*(?:\.?|\b)/;

function getCookieDomain() {
  if (window && window.location && window.location.hostname) {
    var tldMatch = cookieTLDRegex.exec(window.location.hostname);
    var strippedUrl = stripWWWRegex.exec(window.location.hostname);

    if (tldMatch !== null) {
      // Basically if we have a website like foo.bar.example.com and the TLD is
      // example.com, if we set a cookie to .example.com it will not work on the subdomain
      // foo.bar.example.com but it would for bar.example.com. In the case of
      // multiple subdomains we just set the domain to the stripped URL
      // This will still cover the case if there is another subdomain ie:
      // checkout.foo.bar.example.com will see the cookies set on the domain
      // .foo.bar.example.com
      if (strippedUrl !== null && (strippedUrl[0].match(/\./g) || []).length > 2) {
        return ".".concat(strippedUrl[0]);
      } // eslint-disable-next-line prefer-destructuring


      return tldMatch[0];
    }
  }

  return undefined;
}

export default getCookieDomain;
//# sourceMappingURL=get-cookie-domain.js.map